import { render } from "./Manager.vue?vue&type=template&id=0af3cb43"
import script from "./Manager.vue?vue&type=script&lang=js"
export * from "./Manager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__